import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDT, EVENT_KINDS } from "@/lib/plannerOptions";
import { Panel, Empty, Row } from "@/components/dashboard/Panel";

export const UpcomingWidget = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/events/upcoming", { params: { days: 7 } }).then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <Panel title="Yaklaşan randevular" icon={CalendarClock} link="/calendar" linkLabel="Takvim" testId="upcoming-widget">
      {items.length === 0 ? <Empty>Önümüzdeki 7 günde kayıt yok</Empty> : items.slice(0, 5).map((e) => (
        <Row key={e.id} testId={`upcoming-${e.id}`} title={e.title} sub={EVENT_KINDS[e.kind]}
          right={<span className="text-[11px] font-semibold rounded-full px-2 py-0.5 bg-emerald-50 text-emerald-700">{fmtDT(e.start)}</span>} />
      ))}
      {items.length > 5 && <Link to="/calendar" className="block text-center text-xs text-emerald-700 mt-2">+{items.length - 5} kayıt daha</Link>}
    </Panel>
  );
};
